<div class="container-fluid pt-3">
  <ab-route-cards
    [routesStats]="routesStats"
    [statusCode]="totalStatus"
    [loading]="loadingRoutesStats"
    [project]="project"
    [dur]="dur"
    [lastN]="lastN"
    [errorRateList]="errorRateList"
    [showPerformanceBreakdown]="false"
  ></ab-route-cards>
</div>
<div class="container-fluid">
  <ab-route-charts
    class="row pt-3"
    [routesStats]="routesStats"
    [statusCode]="totalStatus"
    [loading]="loadingRoutesStats"
    [project]="project"
    [dur]="dur"
    [lastN]="lastN"
  ></ab-route-charts>
</div>
<div class="clearfix pt-3">
  <div class="col-lg-12">
    <ul class="ab-tabs">
      <li class="ab-tabs__item">
        <button
          class="ab-tabs__link"
          uiSref="project-performance"
          [uiParams]="{ currentTab: 'routes' }"
          uiSrefActive="active"
          type="button"
          [disabled]="currentTab === 'routes'"
        >
          Routes
        </button>
      </li>
      <li class="ab-tabs__item">
        <button
          class="ab-tabs__link"
          uiSref="project-performance"
          [uiParams]="{ currentTab: 'queries' }"
          uiSrefActive="active"
          type="button"
          [disabled]="currentTab === 'queries'"
        >
          Queries
        </button>
      </li>
      <li class="ab-tabs__item">
        <button
          class="ab-tabs__link"
          uiSref="project-performance"
          [uiParams]="{ currentTab: 'queues' }"
          uiSrefActive="active"
          type="button"
          [disabled]="currentTab === 'queues'"
        >
          Jobs
        </button>
      </li>
    </ul>
    <ng-container *ngIf="currentTab === 'queries'">
      <ab-query-list
        [project]="project"
        [timeDurAgo]="timeDurAgo"
        [dur]="dur"
        [queryPage]="queryPage"
        [sortColumn]="sortQueryColumn"
        [sortDesc]="sortQueryDesc"
        [search]="querySearch"
        [environment]="environment"
      ></ab-query-list>
    </ng-container>
    <ng-container *ngIf="currentTab === 'routes' && routes">
      <div class="top-right-pagination">
        <div class="paginate float-md-right">
          <div class="route-counter" *ngIf="totalRoutes > 0">
            {{ totalRoutes }} {{ totalRoutes | pluralize: "Route" }}, Page
            {{ currentPage }} of {{ totalPages }}
          </div>
          <div class="btn-group">
            <button
              class="btn"
              (click)="loadPage(currentPage - 1)"
              [disabled]="currentPage === 1 || totalPages === 0"
              type="button"
            >
              <i class="glyphicon glyphicon-angle-left"></i>
            </button>
            <button
              class="btn"
              (click)="loadPage(currentPage + 1)"
              [disabled]="currentPage >= totalPages"
              type="button"
            >
              <i class="glyphicon glyphicon-angle-right"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="content-mask" *ngIf="loadingRoutes">
        <ab-spinner></ab-spinner>
      </div>
      <div class="ab-table-wrap">
        <div class="ab-table">
          <div class="ab-table__row-grid">
            <div class="ab-table__header"></div>
            <div class="ab-table__header ab-table__header--left-border">
              Requests
            </div>
            <div class="ab-table__header"></div>
            <div class="ab-table__header ab-table__header--left-border">
              Response codes
            </div>
            <div class="ab-table__header ab-table__header--left-border">
              Response time (percentile)
            </div>
            <div class="ab-table__header"></div>
            <div class="ab-table__header ab-table__header--left-border">
              Error occurrences
            </div>
          </div>
        </div>
        <div class="ab-table">
          <div class="ab-table__row-grid">
            <div class="ab-table__header">
              <a class="th-link" (click)="sortBy('route')"
                >Route<i
                  class="glyphicon th-link__icon"
                  *ngIf="sortColumn === 'route'"
                  [ngClass]="{
                    'glyphicon-caret-up': !sortDesc,
                    'glyphicon-caret-down': sortDesc
                  }"
                ></i
              ></a>
              <input
                class="color--grey-400"
                type="text"
                placeholder="Filter routes"
                [disabled]="loadingRoutesStats"
                [(ngModel)]="routeSearch"
                (ngModelChange)="debounceSearchRoute()"
              />
            </div>
            <div class="ab-table__header ab-table__header--left-border">
              <a class="th-link" (click)="sortBy('total.count')"
                >Total<i
                  class="glyphicon th-link__icon"
                  *ngIf="sortColumn === 'total.count'"
                  [ngClass]="{
                    'glyphicon-caret-up': !sortDesc,
                    'glyphicon-caret-down': sortDesc
                  }"
                ></i
              ></a>
            </div>
            <div class="ab-table__header">
              <a class="th-link" (click)="sortBy('total.requestRate')"
                >Rate<i
                  class="glyphicon th-link__icon"
                  *ngIf="sortColumn === 'total.requestRate'"
                  [ngClass]="{
                    'glyphicon-caret-up': !sortDesc,
                    'glyphicon-caret-down': sortDesc
                  }"
                ></i
              ></a>
            </div>
            <div class="ab-table__header ab-table__header--left-border">
              <a class="th-link" (click)="sortBy('success.count')"
                >2xx<i
                  class="glyphicon th-link__icon"
                  *ngIf="sortColumn === 'success.count'"
                  [ngClass]="{
                    'glyphicon-caret-up': !sortDesc,
                    'glyphicon-caret-down': sortDesc
                  }"
                ></i></a
              ><a
                class="th-link th-link--left-padding"
                (click)="sortBy('redirection.count')"
                >3xx<i
                  class="glyphicon th-link__icon"
                  *ngIf="sortColumn === 'redirection.count'"
                  [ngClass]="{
                    'glyphicon-caret-up': !sortDesc,
                    'glyphicon-caret-down': sortDesc
                  }"
                ></i></a
              ><a
                class="th-link th-link--left-padding"
                (click)="sortBy('clientError.count')"
                >4xx<i
                  class="glyphicon th-link__icon"
                  *ngIf="sortColumn === 'clientError.count'"
                  [ngClass]="{
                    'glyphicon-caret-up': !sortDesc,
                    'glyphicon-caret-down': sortDesc
                  }"
                ></i></a
              ><a
                class="th-link th-link--left-padding"
                (click)="sortBy('serverError.count')"
                >5xx<i
                  class="glyphicon th-link__icon"
                  *ngIf="sortColumn === 'serverError.count'"
                  [ngClass]="{
                    'glyphicon-caret-up': !sortDesc,
                    'glyphicon-caret-down': sortDesc
                  }"
                ></i
              ></a>
            </div>
            <div class="ab-table__header ab-table__header--left-border">
              <a class="th-link" (click)="sortBy('total.p50')"
                >50th<i
                  class="glyphicon th-link__icon"
                  *ngIf="sortColumn === 'total.p50'"
                  [ngClass]="{
                    'glyphicon-caret-up': !sortDesc,
                    'glyphicon-caret-down': sortDesc
                  }"
                ></i
              ></a>
            </div>
            <div class="ab-table__header">
              <a class="th-link" (click)="sortBy('total.p95')"
                >95th<i
                  class="glyphicon th-link__icon"
                  *ngIf="sortColumn === 'total.p95'"
                  [ngClass]="{
                    'glyphicon-caret-up': !sortDesc,
                    'glyphicon-caret-down': sortDesc
                  }"
                ></i
              ></a>
            </div>
            <div class="ab-table__header ab-table__header--left-border">
              <a class="th-link" (click)="sortBy('noticeCount')"
                >Total<i
                  class="glyphicon th-link__icon"
                  *ngIf="sortColumn === 'noticeCount'"
                  [ngClass]="{
                    'glyphicon-caret-up': !sortDesc,
                    'glyphicon-caret-down': sortDesc
                  }"
                ></i
              ></a>
            </div>
            <div class="ab-table__header">
              <a class="th-link" (click)="sortBy('error_rate')"
                >Rate<i
                  class="glyphicon th-link__icon"
                  *ngIf="sortColumn === 'error_rate'"
                  [ngClass]="{
                    'glyphicon-caret-up': !sortDesc,
                    'glyphicon-caret-down': sortDesc
                  }"
                ></i
              ></a>
            </div>
          </div>
        </div>
        <div class="ab-table">
          <div
            class="ab-table__row-hoverable ab-table__row-grid"
            *ngFor="let route of routes; trackBy: trackBy"
          >
            <a
              class="ab-table__cell"
              uiSref="routes-show"
              [uiParams]="{
                projectId: project.id,
                routeId: route.routeId,
                status: route.status,
                dur: dur,
                last_n: lastN
              }"
              [uiOptions]="{ inherit: false }"
              ><span>
                <ab-env-label
                  [env]="route.environment"
                  [truncate]="true"
                ></ab-env-label
                >&nbsp;
                <ab-route-method [method]="route.method"></ab-route-method
                >&nbsp;
                <ab-route-name
                  [routeName]="route.route"
                ></ab-route-name></span></a
            ><a
              class="ab-table__cell"
              uiSref="routes-show"
              [uiParams]="{
                projectId: project.id,
                routeId: route.routeId,
                status: route.status,
                dur: dur,
                last_n: lastN
              }"
              [uiOptions]="{ inherit: false }"
              >{{ route.total.count | numberToHuman }}</a
            ><a
              class="ab-table__cell ab-table__cell--no-wrap"
              uiSref="routes-show"
              [uiParams]="{
                projectId: project.id,
                routeId: route.routeId,
                status: route.status,
                dur: dur,
                last_n: lastN
              }"
              [uiOptions]="{ inherit: false }"
              >{{ route.total.requestRate | rateFormat
              }}<span class="text-small">/min</span></a
            ><a
              class="ab-table__cell ab-table__cell-no-top-padding"
              uiSref="routes-show"
              [uiParams]="{
                projectId: project.id,
                routeId: route.routeId,
                status: route.status,
                dur: dur,
                last_n: lastN
              }"
              [uiOptions]="{ inherit: false }"
            >
              <ab-response-codes-bar
                class="response-codes-bar-container"
                [data]="route.total.responseCodesBarData"
              ></ab-response-codes-bar></a
            ><a
              class="ab-table__cell"
              [ngClass]="route.total.p50ResponseTimeClass"
              uiSref="routes-show"
              [uiParams]="{
                projectId: project.id,
                routeId: route.routeId,
                status: route.status,
                dur: dur,
                last_n: lastN
              }"
              [uiOptions]="{ inherit: false }"
              ><ab-duration-format
                [milliseconds]="route.total.p50"
              ></ab-duration-format></a
            ><a
              class="ab-table__cell"
              [ngClass]="route.total.p95ResponseTimeClass"
              uiSref="routes-show"
              [uiParams]="{
                projectId: project.id,
                routeId: route.routeId,
                status: route.status,
                dur: dur,
                last_n: lastN
              }"
              [uiOptions]="{ inherit: false }"
              ><ab-duration-format
                [milliseconds]="route.total.p95"
              ></ab-duration-format
            ></a>
            <div class="ab-table__cell">
              <a
                *ngIf="route.noticeCount > 0"
                (click)="$event.stopPropagation()"
                uiSref="project-errors"
                [uiParams]="{
                  projectId: project.id,
                  filters: {
                    'context.route': route.route,
                    'context.httpMethod': route.method,
                    'context.environment': route.environment,
                    start_time: startTime,
                    resolved: 'any'
                  }
                }"
                >{{ route.noticeCount | numberToHuman }}</a
              ><span *ngIf="route.noticeCount === 0">{{
                route.noticeCount | numberToHuman
              }}</span>
            </div>
            <a
              class="ab-table__cell ab-table__cell--no-wrap"
              uiSref="routes-show"
              [uiParams]="{
                projectId: project.id,
                routeId: route.routeId,
                status: route.status,
                dur: dur,
                last_n: lastN
              }"
              [uiOptions]="{ inherit: false }"
              >{{ route.errorRate * 100 | rateFormat
              }}<span class="text-unit">%</span></a
            >
          </div>
        </div>
      </div>
      <div class="blankslate" *ngIf="routes.length === 0">
        <p class="blankslate__text">No data for the chosen time period</p>
        <img
          class="blankslate__image"
          src="{{ appEnv.cdnUrl }}/{{
            appEnv.assetsPath
          }}/images/blankslate.svg"
        />
      </div>
    </ng-container>
    <ng-container *ngIf="currentTab === 'queues'">
      <ab-queue-list
        [project]="project"
        [timeDurAgo]="timeDurAgo"
        [dur]="dur"
        [queuePage]="queuePage"
        [search]="queueSearch"
        [sortColumn]="sortQueueColumn"
        [sortDesc]="sortQueueDesc"
        [environment]="environment"
      >
      </ab-queue-list>
    </ng-container>
  </div>
</div>
